<template>
  <div class="pb-3">
    <div class="text-center"  v-if="popupBatchUpdate.isLoading">
			<img src="@/assets/loading-logo-animation.gif" style="width: 75px"/>
			
			<p class="font-weight-bold">{{$t('THE_SYSTEM_IS_LOADING')}}</p>
		</div>
    <v-row align="center" class="m-0" v-if="!popupBatchUpdate.isLoading">
      <v-col md="8" class="py-0" style="display: flex">
        <v-radio-group
          v-model="popupBatchUpdate.price.action"
          row
          class="mt-0"
          @change="changeAction()"
        >
          <v-radio
            :label="$t('FAST_UPDATE')"
            value="massUpdate"
            color="primary"
          ></v-radio>
          <v-radio
            :label="$t('RESTRICTION_BULK_UPDATE')"
            value="update"
            color="primary"
          ></v-radio>
          <v-radio
            :label="$t('DELETE')"
            value="delete"
            color="primary"
          ></v-radio>
        </v-radio-group>
      </v-col>
      <v-col class="text-right py-0">
				<v-btn color="primary" @click="confirmUpdateSpecialPrice()" :disabled="popupBatchUpdate.isLoading">
					<template>{{ $t("UPDATE") }}</template>
				</v-btn>
			</v-col>
    </v-row>
    <v-row class="m-0" v-if="!popupBatchUpdate.isLoading">
			<v-col md="12" >
				<v-row >
					<v-col md="4" class="py-0">
						<label class="pr-0" style="padding-top: 11px; margin-right: 12px; white-space: nowrap;">
							{{ $t("METADATA") }} *
						</label>
						<v-select item-text="text" item-value="value" :items="popupBatchUpdate.price.extraType" v-model="popupBatchUpdate.price.extraTypeSelected" outlined dense >
							<template slot="no-data">
								<div class="no-data">{{ $t("NO_DATA") }}</div>
							</template>
						</v-select>
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<label class="pr-0" style="padding-top: 11px; margin-right: 12px; white-space: nowrap;"> 
							{{ $t("ROOM_TYPE")}} *
						</label>
						<v-autocomplete item-text="text" item-value="value" :items="listRoom.filter((x) => x.value != -1)"
							v-model.lazy="popupBatchUpdate.select.roomType" outlined chips dense multiple @change="checkProductUpdate()">
							<template v-slot:prepend-item>
								<p class="mx-3 mt-1"> <a class="text-primary"
										@click="popupBatchUpdate.select.roomType = listRoom.map(e => e.value); checkProductUpdate()">{{
											$t('SELECT_ALL') }}</a>
									| <a class="text-primary" @click="popupBatchUpdate.select.roomType = []">{{
										$t('UN_SELECT_ALL') }}</a>
								</p>
							</template>

							<template v-slot:selection="{ item, index }">
								<v-chip color="primary" v-if="index === 0 || index === 1" v-bind="item.attrs"
									:input-value="item.selected" close
									@click:close="removeChips(index, popupBatchUpdate.select.roomType)" @click="item.select">
									<span>{{ item.text }}</span>
								</v-chip>
								<span v-if="index === 2" class="grey--text caption">(+{{
									popupBatchUpdate.select.roomType.length - 2 }})</span>
							</template>
							<template slot="no-data">
								<div class="no-data">{{ $t("NO_DATA") }}</div>
							</template>
						</v-autocomplete>
					</v-col>
					<v-col>
						<label class="pr-0" style="padding-top: 11px; margin-right: 12px; white-space: nowrap;"> {{
							$t("SALE_PACKAGE") }} *</label>
						<v-autocomplete item-text="text" item-value="value" :items="planList" v-model.lazy="popupBatchUpdate.select.ratePlan" outlined @change="checkProductUpdate()"
							chips dense multiple>
							<template v-slot:prepend-item>
								<p class="mx-3 mt-1"> 
									<a class="text-primary" @click="popupBatchUpdate.select.ratePlan = planList.map(e => e.value); checkProductUpdate()">{{ $t('SELECT_ALL') }}</a> | 
									<a class="text-primary" @click="popupBatchUpdate.select.ratePlan = []">{{ $t('UN_SELECT_ALL') }}</a>
								</p>
							</template>
							<template v-slot:selection="{ item, index }">
								<v-chip color="primary" v-if="index === 0 || index === 1" v-bind="item.attrs"
									:input-value="item.selected" close @click:close="removeChips(index, popupBatchUpdate.select.ratePlan)"
									@click="item.select">
									<span>{{ item.text }}</span>
								</v-chip>
								<span v-if="index === 2" class="grey--text caption">(+{{ popupBatchUpdate.select.ratePlan.length - 2 }})</span>
							</template>
							<template slot="no-data">
								<div class="no-data">{{ $t("NO_DATA") }}</div>
							</template>
						</v-autocomplete>
					</v-col>
					<v-col>
						<label class="pr-0" style="padding-top: 11px; margin-right: 12px; white-space: nowrap;">
							{{ $t("SALE_CHANNEL") }} *
						</label>
						<v-autocomplete item-text="text" item-value="value" :items="listOTA"
							v-model="popupBatchUpdate.select.ota" outlined dense multiple>
							<template v-slot:prepend-item>
								<p class="mx-3 mt-1"> <a class="text-primary"
										@click="popupBatchUpdate.select.ota = listOTA.map(e => e.value)">{{
											$t('SELECT_ALL') }}</a>
									| <a class="text-primary" @click="popupBatchUpdate.select.ota = []">{{
										$t('UN_SELECT_ALL') }}</a>
								</p>
							</template>
							<template v-slot:selection="{ item, index }">
								<v-chip color="primary" v-if="index === 0 || index === 1" v-bind="item.attrs"
									:input-value="item.selected" close
									@click:close="removeChips(index, popupBatchUpdate.select.ota)" @click="item.select">
									<span>{{ item.text }}</span>
								</v-chip>
								<span v-if="index === 2" class="grey--text caption">(+{{
									popupBatchUpdate.select.ota.length - 2 }})</span>
							</template>
							<template slot="no-data">
								<div class="no-data">{{ $t("NO_DATA") }}</div>
							</template>
						</v-autocomplete>
					</v-col>
				</v-row>
			</v-col>
		</v-row>

    <v-row
      class="config-price"
      v-if="popupBatchUpdate.price.action !== 'massUpdate' && !popupBatchUpdate.isLoading"
    >
      <template>
        <div class="w-100 px-3">
          <div class="d-sticky h-header-table d-flex px-1">
            <div class="mr-auto"></div> 
            <div> 	
              <div class="small-gutters d-flex"> 	
                <div class="text-center font-weight-bold w-input-update"  v-for="item in popupBatchUpdate.daysOfWeek" :key="item.value">{{ item.value }}</div>
                <div class="text-center font-weight-bold d-input-sl">{{  $t("PERSON_NUMBER") }}</div> 	
              </div> 
            </div>
          </div>
          <div class="px-3"
            v-for="(room, roomIndex) in popupBatchUpdate.price.hasRoomRate.filter((temp) => popupBatchUpdate.select.roomType.includes(temp.roomTypeId) 
					&& temp.roomRates.filter(item => popupBatchUpdate.select.ratePlan.includes(item.ratePlanId)).length > 0 
					&& temp.roomRates.filter(item => popupBatchUpdate.select.ratePlan.includes(item.ratePlanId)).filter(rr => rr.ota.filter(o => popupBatchUpdate.select.ota.includes(o.ota.id)).length > 0).length > 0
					)">
            <div
              class="pb-0 pt-2"
              v-for="(plan, indexPlan) in room.roomRates.filter(item => popupBatchUpdate.select.ratePlan.includes(item.ratePlanId) 
            && item.ota.filter(o => popupBatchUpdate.select.ota.includes(o.ota.id)).length > 0)"
            >
              <span class="font-weight-bold text-primary">
                {{ room.romTypeNameI18ns.find(x => x.lang == defaultI18n).name }}
                -
                {{ plan.romPlanNameI18ns.find(x => x.lang == defaultI18n).name }}
              </span>
              <p v-if="`${room.roomTypeId}_${plan.ratePlanId}` in updateErrors" class="mb-0 protection-rate-error text-danger">{{updateErrors[`${room.roomTypeId}_${plan.ratePlanId}`]}}</p>
              <div v-for="(detail, indexDetail) in plan.ota.filter(item => popupBatchUpdate.select.ota.includes(item.ota.id))">
                <b-row class="my-1">
                  <v-col md="6" class="py-0">
                    <div
                      style="font-size: 13px"
                      class="d-flex align-center h-100 text-primary"
                    >
                      {{
                        detail.ota.otaI18n.find(x => x.lang == defaultI18n).name
                      }}
                    </div>
                  </v-col>
                  <v-col md="6" class="py-0 text-right">
                    <div  class="text-right d-flex justify-content-end">
                      <span class="font-weight-bold"  v-if=" roomIndex === 0 && indexDetail === 0 && indexPlan === 0 && popupBatchUpdate.price.action === 'update'"> Master 
												<v-tooltip top>
													<template v-slot:activator="{ on, attrs }">
														<v-icon size="16" v-bind="attrs"
														v-on="on">info</v-icon>
													</template>
													<span>{{$t('TOOLTIP_MASTER')}}</span>
												</v-tooltip>
											</span>
											<div class="d-flex align-center justify-content-end d-multiplier" v-else-if="popupBatchUpdate.price.action === 'update'">
												<div class="mr-1">
													<span class="font-weight-bold"> Master *</span>
												</div>
												<div>
													<currency-ptd
														:classC="'v-input__slot mb-0 mx-input py-0 rounded input-multiplier'"  :options="multiplierOption" v-model.lazy="detail.multiplier"/>
												</div> 
												<span class="font-weight-bold pl-1 pr-1"> + </span>
												<div class="mr-1">
													<currency-ptd
														:classC="'v-input__slot mb-0 mx-input py-0 rounded input-plus'"  class="input-plus" :options="currency == 'VND' ? priceOptionsVi : priceOptionsEn" v-model.lazy="detail.plus"/>
												</div>
												<v-btn color="primary" outlined x-small @click="copyMasterRate(detail)" :title="$t('COPY_BY_FOMULAR')"> 
													<v-icon size="16">move_down</v-icon>
												</v-btn>
											</div>
                      <div class="ml-3 d-flex align-center">
                        <v-btn
                          x-small
                          color="primary"
                          :title="$t('COPY')"
                          @click="copyMaster(detail.dates)"
                        >
                          <v-icon size="16">copy_all</v-icon>
                        </v-btn>
                        <v-btn
                          x-small
                          color="primary"
                          class="ml-1"
                          :title="$t('PASTE')"
                          @click="pasteMaster(detail)"
                          v-if="objectCopy"
                        >
                          <v-icon size="16">content_paste</v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </v-col>
                </b-row>
                <template v-for="(date, indDate) in detail.dates">
                  <div class="align-center mt-0 mb-1 d-flex">
                    <div class="d-date mr-auto">
                      <template
                        v-if="
                          roomIndex === 0 &&
                            indexDetail === 0 &&
                            indexPlan === 0
                        "
                      >
                        <div class="d-flex">
                          <date-picker
                            :disabled-date="notBeforeToday"
                            @input="changDate(detail)"
                            :confirm="true"
                            :confirm-text="$t('CONFIRM')"
                            :clearable="false"
                            :popup-class="'popup-calendar-desktop-detailhotel'"
                            v-model="date.dateSelect"
                            :lang="languageDate"
                            :format="'DD/MM/YYYY'"
                            :shortcuts="[]"
                            range
                            placeholder="Select date range"
                          >
                          </date-picker>
                          <v-icon
                            v-if="detail.dates.length > 1"
                            color="red"
                            size="16"
                            class="ml-3"
                            @click="removePeriodSpecialPrice(indDate)"
                            >delete</v-icon
                          >
                        </div>
                      </template>
                      <template v-else>
                        {{ _moment(date.dateSelect[0]).format("DD/MM/YYYY") }} -
                        {{ _moment(date.dateSelect[1]).format("DD/MM/YYYY") }}
                      </template>
                    </div>
                    <div>
                      <div
                        class="small-gutters"
                        v-if="popupBatchUpdate.price.action === 'update'"
                      >
                        <div class="d-flex">
                          <v-icon
                            size="16"
                            color="primary"
                            @click="copyPrice(date)"
                            class="mr-2"
                            :title="$t('COPY')"
                            >content_paste_go</v-icon
                          >
                          <currency-ptd
														:classC="[
                              'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded', 
                              `${room.roomTypeId}_${plan.ratePlanId}` in updateErrors && 
                              protectionRateInvalid(room.priceMin, room.priceMax, date['MON'].value) 
                              ? 'protection-border-danger' 
                              : ''
                            ].filter(Boolean).join(' ')"
                            :disabled="date['MON'].disable"
                            :options="
                              currency == 'VND'
                                ? priceOptionsVi
                                : priceOptionsEn
                            "
                            v-model.lazy="date['MON'].value"
                          />
                        </div>
                        <div>
                          <currency-ptd
														:classC="[
                              'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded', 
                              `${room.roomTypeId}_${plan.ratePlanId}` in updateErrors && 
                              protectionRateInvalid(room.priceMin, room.priceMax, date['TUE'].value) 
                              ? 'protection-border-danger' 
                              : ''
                            ].filter(Boolean).join(' ')"
                            :disabled="date['TUE'].disable"
                            :options="
                              currency == 'VND'
                                ? priceOptionsVi
                                : priceOptionsEn
                            "
                            v-model.lazy="date['TUE'].value"
                          />
                        </div>
                        <div>
                          <currency-ptd
														:classC="[
                              'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded', 
                              `${room.roomTypeId}_${plan.ratePlanId}` in updateErrors && 
                              protectionRateInvalid(room.priceMin, room.priceMax, date['WED'].value) 
                              ? 'protection-border-danger' 
                              : ''
                            ].filter(Boolean).join(' ')"
                            :disabled="date['WED'].disable"
                            :options="
                              currency == 'VND'
                                ? priceOptionsVi
                                : priceOptionsEn
                            "
                            v-model.lazy="date['WED'].value"
                          />
                        </div>
                        <div>
                          <currency-ptd
														:classC="[
                              'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded', 
                              `${room.roomTypeId}_${plan.ratePlanId}` in updateErrors && 
                              protectionRateInvalid(room.priceMin, room.priceMax, date['THU'].value) 
                              ? 'protection-border-danger' 
                              : ''
                            ].filter(Boolean).join(' ')"
                            :disabled="date['THU'].disable"
                            :options="
                              currency == 'VND'
                                ? priceOptionsVi
                                : priceOptionsEn
                            "
                            v-model.lazy="date['THU'].value"
                          />
                        </div>
                        <div>
                          <currency-ptd
														:classC="[
                              'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded', 
                              `${room.roomTypeId}_${plan.ratePlanId}` in updateErrors && 
                              protectionRateInvalid(room.priceMin, room.priceMax, date['FRI'].value) 
                              ? 'protection-border-danger' 
                              : ''
                            ].filter(Boolean).join(' ')"
                            :disabled="date['FRI'].disable"
                            :options="
                              currency == 'VND'
                                ? priceOptionsVi
                                : priceOptionsEn
                            "
                            v-model.lazy="date['FRI'].value"
                          />
                        </div>
                        <div>
                          <currency-ptd
														:classC="[
                              'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded', 
                              `${room.roomTypeId}_${plan.ratePlanId}` in updateErrors && 
                              protectionRateInvalid(room.priceMin, room.priceMax, date['SAT'].value) 
                              ? 'protection-border-danger' 
                              : ''
                            ].filter(Boolean).join(' ')"
                            :disabled="date['SAT'].disable"
                            :options="
                              currency == 'VND'
                                ? priceOptionsVi
                                : priceOptionsEn
                            "
                            v-model.lazy="date['SAT'].value"
                          />
                        </div>
                        <div>
                          <currency-ptd
														:classC="[
                              'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded', 
                              `${room.roomTypeId}_${plan.ratePlanId}` in updateErrors && 
                              protectionRateInvalid(room.priceMin, room.priceMax, date['SUN'].value) 
                              ? 'protection-border-danger' 
                              : ''
                            ].filter(Boolean).join(' ')"
                            :disabled="date['SUN'].disable"
                            :options="
                              currency == 'VND'
                                ? priceOptionsVi
                                : priceOptionsEn
                            "
                            v-model.lazy="date['SUN'].value"
                          />
                        </div>
                        <div class="mr-0">
                          <currency-ptd
														:classC="'d-input-sl text-right v-input__slot mb-0 mx-input py-0 rounded'" 
                            :options="{ length: 2, precision: 0 }"
                            v-model.lazy="date.numberPerson"
                            tabindex="1"
                          />
                         
                        </div>
                      </div>
                      <div class="small-gutters" v-else>
                        <div class="d-flex">
                          <v-icon
                            size="16"
                            color="primary"
                            @click="copyPrice(date)"
                            class="mr-2"
                            :title="$t('COPY')"
                            >content_paste_go</v-icon
                          >
                          <b-form-select
                          class="w-input-update"
                            text-field="text"
                            value-field="value"
                            :options="popupBatchUpdate.price.delete.options"
                            :disabled="date['MON'].disable"
                            size="sm"
                            v-model="date['MON'].value"
                          ></b-form-select>
                        </div>
                        <div>
                          <b-form-select
                          class="w-input-update"
                            text-field="text"
                            value-field="value"
                            :options="popupBatchUpdate.price.delete.options"
                            :disabled="date['TUE'].disable"
                            size="sm"
                            v-model="date['TUE'].value"
                          ></b-form-select>
                        </div>
                        <div>
                          <b-form-select
                          class="w-input-update"
                            text-field="text"
                            value-field="value"
                            :options="popupBatchUpdate.price.delete.options"
                            :disabled="date['WED'].disable"
                            size="sm"
                            v-model="date['WED'].value"
                          ></b-form-select>
                        </div>
                        <div>
                          <b-form-select
                          class="w-input-update"
                            text-field="text"
                            value-field="value"
                            :options="popupBatchUpdate.price.delete.options"
                            :disabled="date['THU'].disable"
                            size="sm"
                            v-model="date['THU'].value"
                          ></b-form-select>
                        </div>
                        <div>
                          <b-form-select
                          class="w-input-update"
                            text-field="text"
                            value-field="value"
                            :options="popupBatchUpdate.price.delete.options"
                            :disabled="date['FRI'].disable"
                            size="sm"
                            v-model="date['FRI'].value"
                          ></b-form-select>
                        </div>
                        <div>
                          <b-form-select
                          class="w-input-update"
                            text-field="text"
                            value-field="value"
                            :options="popupBatchUpdate.price.delete.options"
                            :disabled="date['SAT'].disable"
                            size="sm"
                            v-model="date['SAT'].value"
                          ></b-form-select>
                        </div>
                        <div>
                          <b-form-select
                            class="w-input-update"
                            text-field="text"
                            value-field="value"
                            :options="popupBatchUpdate.price.delete.options"
                            :disabled="date['SUN'].disable"
                            size="sm"
                            v-model="date['SUN'].value"
                          ></b-form-select>
                        </div>
                        <div class="mr-0">
                          <currency-ptd
														:classC="'d-input-sl text-right v-input__slot mb-0 mx-input py-0 rounded'" 
                            :options="{ length: 2, precision: 0 }"
                            v-model.lazy="date.numberPerson"
                            tabindex="1"
                          />
                         
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <v-row
                  class="mt-0"
                  v-if="roomIndex === 0 && indexDetail === 0 && indexPlan === 0"
                >
                  <v-col class="pt-0 pb-0">
                    <v-btn
                      color="primary"
                      outlined
                      x-small
                      @click="addDatePriodSpecialPrice()"
                    >
                      <v-icon color="#173d8f" small>add</v-icon>
                      <span class="fs-8">{{ $t("ADD_DATE_RANGE") }}</span>
                    </v-btn>
                  </v-col>
                </v-row>
                <hr class="mb-0" />
              </div>
            </div>
          </div>
        </div>
      </template>
      <template 
        v-if="popupBatchUpdate.price.hasRoomRate.filter((temp) => popupBatchUpdate.select.roomType.includes(temp.roomTypeId) 
					&& temp.roomRates.filter(item => popupBatchUpdate.select.ratePlan.includes(item.ratePlanId)).length > 0 
					&& temp.roomRates.filter(item => popupBatchUpdate.select.ratePlan.includes(item.ratePlanId)).filter(rr => rr.ota.filter(o => popupBatchUpdate.select.ota.includes(o.ota.id)).length > 0).length > 0
					).length === 0"
      >
        <v-col class="text-center">
          <p>{{ $t("NO_DATA") }}</p>
        </v-col>
      </template>
    </v-row>
    <div v-else-if="!popupBatchUpdate.isLoading" class="config-price">
      <div class="w-100">
        <div class="d-sticky h-header-table d-flex">
          <div class="mr-auto"></div> 
          <div> 	
            <div class="small-gutters d-flex"> 	
              <div class="text-center font-weight-bold w-input-update"  v-for="item in popupBatchUpdate.daysOfWeek" >{{ item.value }}</div>
              <div class="text-center font-weight-bold d-input-sl">{{  $t("PERSON_NUMBER") }}</div> 	
            </div> 
          </div>
        </div>
        <div 
          class="d-flex mt-1 px-2"
          :class="`${_moment(date.dateSelect[0]).format('YYYYMMDD')}_${_moment(date.dateSelect[1]).format('YYYYMMDD')}` in updateErrors ? 'mb-4' : 'mb-2'"
          v-for="(date, indDate) in massDate"
          :key="indDate"
        >
          <div class="mr-auto d-date">
            <div class="d-flex">
              <date-picker
                :disabled-date="notBeforeToday"
                @input="changDateMass(date)"
                :confirm="true"
                :confirm-text="$t('CONFIRM')"
                :clearable="false"
                :popup-class="'popup-calendar-desktop-detailhotel'"
                v-model="date.dateSelect"
                :lang="languageDate"
                :format="'DD/MM/YYYY'"
                :shortcuts="[]"
                range
                placeholder="Select date range"
              >
              </date-picker>
              <v-icon
                v-if="massDate.length > 1"
                color="red"
                size="16"
                @click="removePeriodSpecialPriceMass(indDate)"
                class="ml-3"
                >delete</v-icon
              >
            </div>
          </div>
          <div>
            <div class="small-gutters">
              <div class="d-flex">
                <v-icon
                  size="16"
                  color="primary"
                  @click="copyPrice(date)"
                  class="mr-3"
                  :title="$t('COPY')"
                  >content_paste_go</v-icon
                >
                <currency-ptd
									:classC="[
                    'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded', 
                    `${_moment(date.dateSelect[0]).format('YYYYMMDD')}_${_moment(date.dateSelect[1]).format('YYYYMMDD')}` in updateErrors && 
                    protectionRateInvalid(null, minRate, date['MON'].value) 
                    ? 'protection-border-danger' 
                    : ''
                  ].filter(Boolean).join(' ')"
                  :disabled="date['MON'].disable"
                  :options="currency == 'VND' ? priceOptionsVi : priceOptionsEn"
                  dense
                  outlined
                  v-model.lazy="date['MON'].value"
                />
              </div>
              <div>
                <currency-ptd
									:classC="[
                    'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded', 
                    `${_moment(date.dateSelect[0]).format('YYYYMMDD')}_${_moment(date.dateSelect[1]).format('YYYYMMDD')}` in updateErrors && 
                    protectionRateInvalid(null, minRate, date['TUE'].value) 
                    ? 'protection-border-danger' 
                    : ''
                  ].filter(Boolean).join(' ')"
                  :disabled="date['TUE'].disable"
                  :options="currency == 'VND' ? priceOptionsVi : priceOptionsEn"
                  dense
                  outlined
                  v-model.lazy="date['TUE'].value"
                />
              </div>
              <div>
                <currency-ptd
									:classC="[
                    'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded', 
                    `${_moment(date.dateSelect[0]).format('YYYYMMDD')}_${_moment(date.dateSelect[1]).format('YYYYMMDD')}` in updateErrors && 
                    protectionRateInvalid(null, minRate, date['WED'].value) 
                    ? 'protection-border-danger' 
                    : ''
                  ].filter(Boolean).join(' ')"
                  :disabled="date['WED'].disable"
                  :options="currency == 'VND' ? priceOptionsVi : priceOptionsEn"
                  dense
                  outlined
                  v-model.lazy="date['WED'].value"
                />
              </div>
              <div>
                <currency-ptd
									:classC="[
                    'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded', 
                    `${_moment(date.dateSelect[0]).format('YYYYMMDD')}_${_moment(date.dateSelect[1]).format('YYYYMMDD')}` in updateErrors && 
                    protectionRateInvalid(null, minRate, date['THU'].value) 
                    ? 'protection-border-danger' 
                    : ''
                  ].filter(Boolean).join(' ')"
                  :disabled="date['THU'].disable"
                  :options="currency == 'VND' ? priceOptionsVi : priceOptionsEn"
                  dense
                  outlined
                  v-model.lazy="date['THU'].value"
                />
              </div>
              <div>
                <currency-ptd
									:classC="[
                    'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded', 
                    `${_moment(date.dateSelect[0]).format('YYYYMMDD')}_${_moment(date.dateSelect[1]).format('YYYYMMDD')}` in updateErrors && 
                    protectionRateInvalid(null, minRate, date['FRI'].value) 
                    ? 'protection-border-danger' 
                    : ''
                  ].filter(Boolean).join(' ')"
                  :disabled="date['FRI'].disable"
                  :options="currency == 'VND' ? priceOptionsVi : priceOptionsEn"
                  dense
                  outlined
                  v-model.lazy="date['FRI'].value"
                />
              </div>
              <div>
                <currency-ptd
									:classC="[
                    'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded', 
                    `${_moment(date.dateSelect[0]).format('YYYYMMDD')}_${_moment(date.dateSelect[1]).format('YYYYMMDD')}` in updateErrors && 
                    protectionRateInvalid(null, minRate, date['SAT'].value) 
                    ? 'protection-border-danger' 
                    : ''
                  ].filter(Boolean).join(' ')"
                  :disabled="date['SAT'].disable"
                  :options="currency == 'VND' ? priceOptionsVi : priceOptionsEn"
                  dense
                  outlined
                  v-model.lazy="date['SAT'].value"
                />
              </div>
              <div>
                <currency-ptd
									:classC="[
                    'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded', 
                    `${_moment(date.dateSelect[0]).format('YYYYMMDD')}_${_moment(date.dateSelect[1]).format('YYYYMMDD')}` in updateErrors && 
                    protectionRateInvalid(null, minRate, date['SUN'].value) 
                    ? 'protection-border-danger' 
                    : ''
                  ].filter(Boolean).join(' ')"
                  :disabled="date['SUN'].disable"
                  :options="currency == 'VND' ? priceOptionsVi : priceOptionsEn"
                  dense
                  outlined
                  v-model.lazy="date['SUN'].value"
                />
              </div>
              <div class="mr-0">
                <currency-ptd
									:classC="'d-input-sl text-right v-input__slot mb-0 mx-input py-0 rounded'" 
                  :options="{ length: 2, precision: 0 }"
                  dense
                  outlined
                  v-model.lazy="date.numberPerson"
                  tabindex="1"
                />
              </div>
            </div>
            <div 
              class="ml-7 protection-rate-error text-danger" 
              style="margin-top: -3px !important;" 
              v-if="`${_moment(date.dateSelect[0]).format('YYYYMMDD')}_${_moment(date.dateSelect[1]).format('YYYYMMDD')}` in updateErrors"
            >
              {{updateErrors[`${_moment(date.dateSelect[0]).format('YYYYMMDD')}_${_moment(date.dateSelect[1]).format('YYYYMMDD')}`]}}
            </div>
          </div>
        </div>
        <div class="px-2">
            <v-btn
              color="primary"
              outlined
              x-small
              @click="addDatePriodSpecialPriceMass()"
            >
              <v-icon color="#173d8f" small>add</v-icon>
              <span class="fs-8">{{ $t("ADD_DATE_RANGE") }}</span>
            </v-btn>
          </div>
      </div>
    </div>
    <div class="text-right pt-3 px-3" v-if="!popupBatchUpdate.isLoading">
      <v-btn color="primary" @click="confirmUpdateSpecialPrice()">
        <template
          >{{ $t("UPDATE") }}</template
        >
      </v-btn>
    </div>
    <v-dialog v-model="dialogWarning" :persistent="true" width="500" >
			<v-toolbar class="toolbar-update" dense >
				<v-toolbar-title class="text-primary fs-15">
				<strong>{{ $t('WARNING') }}</strong>
				</v-toolbar-title>
			</v-toolbar>
			<div class="content-update">
				<label class="s-label">
				{{ $t('TXT_WARNING_OVER') }}
				</label>
				<div class="mt-3 text-center">
					<v-btn color="primary" @click="closeWarning">
					{{ $t("CONFIRM") }}
					</v-btn>
				</div>
			</div>
		</v-dialog>
  </div>
</template>
<script>
import moment from "moment";
import { _alert } from "@/_helpers/function.js";
import { sale_room } from "@/_services/SaleRoom/sale-room.js";
import { restriction } from "@/_services/SaleRoom/restriction.js";
import { syncota } from "@/_services/SyncOTA/syncota.js";
import "vue2-datepicker/index.css";
export default {
  components: {
    "date-picker":  () => import('vue2-datepicker'),
    "currency-ptd": () => import('@/components/Utils/Currency-input.vue'),
  },
  data() {
    return {
      dialogWarning: false,
      planList: [],
			listOTA: [],
      currency: JSON.parse(localStorage.getItem("currency")),
      multiplierOption: {
        prefix: "",
        locale: "vi",
        length: 3,
        precision: 2
      },
      availOptions: {
        locale: "vi",
        length: 3,
        precision: 0
      },
      popupBatchUpdate: {
        isLoading: true,
        price: {
          hasRoomRate: [],
          roomRateSelect: [],
          selectedRoomType: [],
          extraTypeSelected: 0,
          action: "massUpdate",
          delete: {
            options: [
              { text: this.$t("DELETE"), value: -1 },
              { text: this.$t("_ACTIVITY.NO"), value: null }
            ]
          },
          extraType: [
            { value: 0, text: this.$t("priceExtraAdult") },
            { value: 1, text: this.$t("priceExtraChild") },
            { value: 2, text: this.$t("priceExtraBaby") }
          ]
        },
        daysOfWeek: [
          { code: "MON", value: this.$t("MONDAY") },
          { code: "TUE", value: this.$t("TUESDAY") },
          { code: "WED", value: this.$t("WEDNESDAY") },
          { code: "THU", value: this.$t("THURSDAY") },
          { code: "FRI", value: this.$t("FRIDAY") },
          { code: "SAT", value: this.$t("SATURDAY") },
          { code: "SUN", value: this.$t("SUNDAY") }
        ],
        select: {
					roomType: [],
					ratePlan: [],
					ota: []
				}
      },
      listRoom: [],
      currentDate: moment()
        .startOf("day")
        .toDate(),
      selectedDatePicker: moment()
        .startOf("day")
        .format("YYYY-MM-DD"),
      systemLang: this.$i18n.locale,
      maxDate: moment(this.currentDate)
        .add(2, "year")
        .add(14, "day")
        .format("YYYY-MM-DD"),
      selectedRoom: -1,
      objectCopy: null,
      massDate: [],
      panel: [0],
      updateErrors: {},
      minRate: null,
    };
  },
  computed: {},
  created() {
    this.currency = this.priceOptionsVi.suffix;
    this.initialize();
  },
  watch: {
    popupBatchUpdate: {
      handler(val) {
        val.price.hasRoomRate.forEach(room => {
          const arrRoomRateIds = []
          room.roomRates.forEach(plan => {
            plan.ota.forEach(detail => {
              detail.dates.forEach(date => {
                var start = moment(date.dateSelect[0], "YYYY-MM-DD");
                var end = moment(date.dateSelect[1], "YYYY-MM-DD");

                // Kiểm tra khoảng ngày hiện tại có lớn hơn 7, nếu lớn hơn thì enable tất cả, nếu ko thì xem khoảng ngày có ngày nào.
                let day = moment.duration(end.diff(start)).asDays();
                // Reset lại toàn bộ
                if (day < 6) {
                  while (start <= end) {
                    let daysOfWeek = this.formatDateOfWeek(start);
                    // Mở các thứ ở trong khoảng
                    date[daysOfWeek].disable = false;
                    start = moment(start).add(1, "day");
                  }
                } else {
                  // Nếu khoảng ngày trải dài cả tuần thì mở hết.
                  date.MON.disable = false;
                  date.TUE.disable = false;
                  date.WED.disable = false;
                  date.THU.disable = false;
                  date.FRI.disable = false;
                  date.SAT.disable = false;
                  date.SUN.disable = false;
                }
              });
              arrRoomRateIds.push(detail.roomrateId);
            });
          });
          let check = true
          arrRoomRateIds.forEach(item => {
            if (!val.price.roomRateSelect.includes(item)) {
              check = false
            }
          })
          room.selectAll = check
        });
        this.updateErrors = {};
      },
      deep: true
    },
    massDate: {
      handler(val) {
        val.forEach(date => {
          var start = moment(date.dateSelect[0], "YYYY-MM-DD");
          var end = moment(date.dateSelect[1], "YYYY-MM-DD");

          // Kiểm tra khoảng ngày hiện tại có lớn hơn 7, nếu lớn hơn thì enable tất cả, nếu ko thì xem khoảng ngày có ngày nào.
          let day = moment.duration(end.diff(start)).asDays();
          // Reset lại toàn bộ
          if (day < 6) {
            while (start <= end) {
              let daysOfWeek = this.formatDateOfWeek(start);
              // Mở các thứ ở trong khoảng
              date[daysOfWeek].disable = false;
              start = moment(start).add(1, "day");
            }
          } else {
            // Nếu khoảng ngày trải dài cả tuần thì mở hết.
            date.MON.disable = false;
            date.TUE.disable = false;
            date.WED.disable = false;
            date.THU.disable = false;
            date.FRI.disable = false;
            date.SAT.disable = false;
            date.SUN.disable = false;
          }
        });
        this.updateErrors = {};
      },
      deep: true
    }
  },
  methods: {
    checkValidate() {
			this.updateErrors = {};
      const dateOfWeek = ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"];
			if (['massUpdate', 'update'].includes(this.popupBatchUpdate.price.action)) {
				if (this.popupBatchUpdate.price.action == 'massUpdate') {
          let minRate = this.popupBatchUpdate.price.hasRoomRate
					.filter(item => this.popupBatchUpdate.select.roomType.includes(item.roomTypeId) && item.priceMax !== null && item.priceMax !== '')
					.reduce((min, item) => Math.min(min, item.priceMax), Infinity);
					this.minRate = minRate >= 0 ? minRate : null;
					
          this.massDate.forEach((date) => {
						for (let i = 0; i < dateOfWeek.length; i++) {
              	let value = date[dateOfWeek[i]].value;
                if (value !== null && this.minRate !== null && value > this.minRate) {
								  const key = `${moment(date.dateSelect[0]).format('YYYYMMDD')}_${moment(date.dateSelect[1]).format('YYYYMMDD')}`;
                  this.updateErrors[key] = this.$t("SAFE_PRICE_RANGE.MAXIMUM_RATE_INPUT_INVALID", {priceMax: this.formatCurrencyWithSymbol(this.minRate)});
								break;
							}
            }
					});
				}

				if (this.popupBatchUpdate.price.action == 'update') {
					const errors = new Map();

					const roomRate = this.popupBatchUpdate.price.hasRoomRate.filter(
						item => this.popupBatchUpdate.select.roomType.includes(item.roomTypeId) && item.priceMax >= 0
					);

					roomRate.forEach(room => {
            const priceMax = room.priceMax;
						room.roomRates
							.filter(rate => this.popupBatchUpdate.select.ratePlan.includes(rate.ratePlanId))
							.forEach(rate => {
								const id = `${room.roomTypeId}_${rate.ratePlanId}`;
								if (!errors.has(id)) {
                  const otas = rate.ota.filter(o => this.popupBatchUpdate.select.ota.includes(o.ota.id));
                  otas.forEach((ota) =>{
                    const dates = ota.dates;
                    dates.forEach((date) => {
                      for (let i = 0; i < dateOfWeek.length; i++) {
                        let value = date[dateOfWeek[i]].value;
                        if (value !== null && priceMax !== null && value > priceMax) {
                          errors.set(
                            id,
                            this.$t("SAFE_PRICE_RANGE.MAXIMUM_RATE_INPUT_INVALID", {
                              priceMax: this.formatCurrencyWithSymbol(priceMax),
                            })
                          );
                          break;
                        }
                      }
                    });
                  });
								}
							});
					});

					if (errors.size > 0) {
						this.updateErrors = Object.fromEntries(errors);
					}
				}
				return Object.keys(this.updateErrors).length == 0;
			}
			return true;
		},
    closeWarning() {
			this.popupBatchUpdate.select.ratePlan = [];
			this.dialogWarning = false
		},
    checkProductUpdate() {
			let dataUpdate = 0;
			if (this.popupBatchUpdate.price.action !== 'massUpdate') {
				 this.popupBatchUpdate.price.hasRoomRate.forEach(e => {
					if ( this.popupBatchUpdate.select.roomType.includes(e.roomTypeId)) {
						
						e.roomRates.forEach(rr => {
							if( this.popupBatchUpdate.select.ratePlan.includes(rr.ratePlanId)) {
								dataUpdate += 1;
							}
						})
					}
				 });
			}
			if (dataUpdate > 50) {
				this.dialogWarning = true;
			}
		},
    async initialize(isSearch) {
      this.popupBatchUpdate.isLoading = true;
      // Nếu là search thì không lấy lại list OTA nữa, ko dùng OTA đầu tiên như khi mới vào.
      this.massDate.push({
        dateSelect: [
          new Date(moment(this.currentDate).format("YYYY-MM-DD")),
          new Date(
            moment(this.currentDate)
              .add(1, "day")
              .format("YYYY-MM-DD")
          )
        ],
        MON: {
          value: null,
          disable: true
        },
        TUE: {
          value: null,
          disable: true
        },
        WED: {
          value: null,
          disable: true
        },
        THU: {
          value: null,
          disable: true
        },
        FRI: {
          value: null,
          disable: true
        },
        SAT: {
          value: null,
          disable: true
        },
        SUN: {
          value: null,
          disable: true
        },
        numberPerson: 1
      });
      this.getAllRoomDefault();
    },
    loadListRoom(data) {
      this.listRoom = [];
      this.listRoom = this.listRoom.concat(
        data.map(room => {
          return {
            value: room.roomTypeId,
            text: room.romTypeNameI18ns.find(x => x.lang === this.defaultI18n).name
          };
        })
      );
      this.getAllOta();
    },
    async getAllOta() {
			await syncota.getAllOTA({ keyword: "", status: 1 }).then((res) => {
					if (res.responseCode === 0) {
						this.listOTA = res.data.filter((x) => x.otaCode !== 'EZ_PMS').map((x) => {
							return {
								value: x.id,
								text: x.otaI18n.find((y) => y.lang == this.defaultI18n).name
							};
						});
						this.listOTA = this.listOTA.filter((x) => x.value);
            this.listOTA.sort((a, b) => a.text.localeCompare(b.text));
						this.popupBatchUpdate.isLoading = false;
						this.$forceUpdate()
					} else {
						this.popupBatchUpdate.isLoading = false;
						_alert(res, this.$t(res.data), false);
					}
				});
		},
    inDays(d1, d2) {
      var t2 = d2.getTime();
      var t1 = d1.getTime();

      return parseInt((t2 - t1) / (24 * 3600 * 1000));
    },
    copyPrice(date) {
      this.objectCopy = null;
      var value = null;
      if (!date.MON.disable) {
        value = date.MON.value;
      } else if (!date.TUE.disable) {
        value = date.TUE.value;
      } else if (!date.WED.disable) {
        value = date.WED.value;
      } else if (!date.THU.disable) {
        value = date.THU.value;
      } else if (!date.FRI.disable) {
        value = date.FRI.value;
      } else if (!date.SAT.disable) {
        value = date.SAT.value;
      } else if (!date.SUN.disable) {
        value = date.SUN.value;
      }
      date.MON.value = !date.MON.disable ? value : null;
      date.TUE.value = !date.TUE.disable ? value : null;
      date.WED.value = !date.WED.disable ? value : null;
      date.THU.value = !date.THU.disable ? value : null;
      date.FRI.value = !date.FRI.disable ? value : null;
      date.SAT.value = !date.SAT.disable ? value : null;
      date.SUN.value = !date.SUN.disable ? value : null;
    },
    changDate(ota) {
      this.objectCopy = null;
      let arrDate = [];
      ota.dates.forEach(element => {
        arrDate.push(element.dateSelect);
      });
      this.popupBatchUpdate.price.hasRoomRate.forEach(room => {
        room.roomRates.forEach(plan => {
          plan.ota.forEach(detail => {
            detail.dates.forEach((date, index) => {
              date.MON.disable = true;
              date.TUE.disable = true;
              date.WED.disable = true;
              date.THU.disable = true;
              date.FRI.disable = true;
              date.SAT.disable = true;
              date.SUN.disable = true;
              date.dateSelect = arrDate[index];
            });
          });
        });
      });
    },
    changDateMass(date) {
      date.MON.disable = true;
      date.TUE.disable = true;
      date.WED.disable = true;
      date.THU.disable = true;
      date.FRI.disable = true;
      date.SAT.disable = true;
      date.SUN.disable = true;
    },
    async getAllRoomDefault() {
      this.planList = [];
      await restriction.getAllRoomTyeHasRoomRate().then(res => {
        if (res.responseCode == 0) {
          let fromDateListOfPeriod = moment(this.currentDate).format(
            "YYYY-MM-DD"
          );
          let toDateListOfPeriod = moment(this.currentDate)
            .add(1, "day")
            .format("YYYY-MM-DD");
          // List phòng đã có room rate cho cập nhật giá và giá đặc biệt
          res.data.forEach(x => {
            var temp = {
              roomTypeId: x.id,
              romTypeNameI18ns: x.roomTypeI18n,
              roomRates: [],
              selectAll: false,
              priceMin: x.priceMin,
              priceMax: x.priceMax,
            };
            x.ratePlans.forEach(y => {
              let plan = {
								value: y.id,
								text: y.i18ns.find((y) => y.lang == this.defaultI18n).name,
							};
							this.planList.push(plan);
							this.planList = Array.from(new Set(this.planList.map(JSON.stringify))).map(JSON.parse)
              var temp2 = [];
              y.roomRates.filter(o => o.ota.otaCode !== 'EZ_PMS').forEach(z => {
                temp2.push({
                  roomrateId: z.id,
                  dates: [
                    {
                      dateSelect: [
                        new Date(fromDateListOfPeriod),
                        new Date(toDateListOfPeriod)
                      ],
                      MON: {
                        value: null,
                        disable: true
                      },
                      TUE: {
                        value: null,
                        disable: true
                      },
                      WED: {
                        value: null,
                        disable: true
                      },
                      THU: {
                        value: null,
                        disable: true
                      },
                      FRI: {
                        value: null,
                        disable: true
                      },
                      SAT: {
                        value: null,
                        disable: true
                      },
                      SUN: {
                        value: null,
                        disable: true
                      },
                      numberPerson: ''
                    }
                  ],
                  ota: z.ota,
                  multiplier: 1,
                  plus: 0
                });
              });
              temp.roomRates.push({
                ratePlanId: y.id,
                romPlanNameI18ns: y.i18ns,
                ota: temp2
              });
            });
            if (temp.roomRates.length > 0) {
              this.popupBatchUpdate.price.hasRoomRate.push(temp);
            }
            
          });
          this.loadListRoom(this.popupBatchUpdate.price.hasRoomRate);
          const params = JSON.parse(localStorage.getItem("roomRateUpdate"));
          if (params.roomId) {
            this.popupBatchUpdate.select.roomType =  params.roomId != -1 ? [params.roomId] : [];
						this.popupBatchUpdate.select.ratePlan = params.planId != -1 ? [params.planId] : [];
						this.popupBatchUpdate.select.ota = params.OtaId != -1 ? [params.OtaId] : [];
          } else {
						this.popupBatchUpdate.select.roomType.push(res.data[0].id);
					}
          
          // this.popupBatchUpdate.price.roomRateSelect = [...
          //   params.roomRateId ? params.roomRateId  : this.popupBatchUpdate.price.hasRoomRate[0].roomRates[0].ota[0].roomRateId
          // ];
          this.panel = this.popupBatchUpdate.price.hasRoomRate.map((k, i) => i)
        }
      });
    },
    changeAction() {
      this.popupBatchUpdate.select.ratePlan = []
      this.objectCopy = null;
      this.popupBatchUpdate.price.hasRoomRate.forEach(e => {
        e.roomRates.forEach(plan => {
          plan.ota.forEach(date => {
            date.dates.forEach(item => {
              item["MON"].value = null;
              item["TUE"].value = null;
              item["WED"].value = null;
              item["THU"].value = null;
              item["FRI"].value = null;
              item["SAT"].value = null;
              item["SUN"].value = null;
            });
          });
        });
      });
    },
    copyMasterRate(detail) {
      let arrMap = [];
     	this.popupBatchUpdate.price.hasRoomRate
				.filter((temp) => this.popupBatchUpdate.select.roomType.includes(temp.roomTypeId))
				.forEach(r => {
					r.roomRates.filter(rr => this.popupBatchUpdate.select.ratePlan.includes(rr.ratePlanId))
					.forEach(o => {
						o.ota.filter(oo => this.popupBatchUpdate.select.ota.includes(oo.ota.id))
						.forEach(item => {
							arrMap.push(item.dates)
						})
					})
				})
      arrMap[0].forEach((element, index) => {
          detail.dates[index]["MON"].value = detail.dates[index]["MON"].disable ? null :  element["MON"].value*detail.multiplier + +detail.plus;
          detail.dates[index]["TUE"].value = detail.dates[index]["TUE"].disable ? null : element["TUE"].value*detail.multiplier + +detail.plus;
          detail.dates[index]["WED"].value = detail.dates[index]["WED"].disable ? null : element["WED"].value*detail.multiplier + +detail.plus;
          detail.dates[index]["THU"].value = detail.dates[index]["THU"].disable ? null : element["THU"].value*detail.multiplier + +detail.plus;
          detail.dates[index]["FRI"].value = detail.dates[index]["FRI"].disable ? null : element["FRI"].value*detail.multiplier + +detail.plus;
          detail.dates[index]["SAT"].value = detail.dates[index]["SAT"].disable ? null : element["SAT"].value*detail.multiplier + +detail.plus;
          detail.dates[index]["SUN"].value = detail.dates[index]["SUN"].disable ? null : element["SUN"].value*detail.multiplier + +detail.plus;
      });
		
    },
    copyMaster(detail) {
      this.objectCopy = [...detail];
    },
    pasteMaster(detail) {
      if (this.objectCopy) {
        this.objectCopy.forEach((element, index) => {
          detail.dates[index].numberPerson = element.numberPerson;
          detail.dates[index]["MON"].value = element["MON"].value;
          detail.dates[index]["TUE"].value = element["TUE"].value;
          detail.dates[index]["WED"].value = element["WED"].value;
          detail.dates[index]["THU"].value = element["THU"].value;
          detail.dates[index]["FRI"].value = element["FRI"].value;
          detail.dates[index]["SAT"].value = element["SAT"].value;
          detail.dates[index]["SUN"].value = element["SUN"].value;
        });
      }
    },
    confirmUpdateSpecialPrice() {
      if (!this.checkValidate()) return;
      let arrDate = [];
      let check = false;
      if (this.popupBatchUpdate.price.action === "massUpdate") {
        this.massDate.forEach(date => {
          arrDate.push(date.dateSelect);
        });
      } else {
        this.popupBatchUpdate.price.hasRoomRate.filter(temp =>
            this.popupBatchUpdate.select.roomType.includes(temp.roomTypeId)
          )[0].roomRates[0].ota[0].dates.forEach(
          date => {
            arrDate.push(date.dateSelect);
          }
        );
      }
      const dates = [];
      arrDate.forEach((date) => {
        if (this.get_day_of_time(new Date(date[0]), new Date(date[1])) > 365) {
          _alert(null, this.$t("UPDATE_INTERVAL_IS_NOT_MORE_THAN_ONE_YEAR"));
          check = true;
          return true;
        }
        let fromDate = moment(date[0], "YYYY-MM-DD");
        let toDate = moment(date[1], "YYYY-MM-DD");
        while (fromDate <= toDate) {
          dates.push(fromDate.format("YYYY-MM-DD"));
          fromDate = moment(fromDate).add(1, "day");
        }
      });
      if (dates.filter((item, index) => dates.indexOf(item) !== index).length > 0) {
        _alert(null, this.$t("_BATCH_UPDATE.MESSAGE.OVERLAP_TIME"));
        return;
      }

      var body = [];
      const hasInvalidExtraOrder = (payload) => {
        return payload.some(item => {
          if (!item.persons || !Array.isArray(item.persons)) {
            return true;
          }
          return item.persons.some(person => {
            const extraOrder = person.extraOrder;
            if (extraOrder === null || extraOrder === undefined) {
              return true;
            }
            if (typeof extraOrder === "string" && extraOrder.trim() === "") {
              return true;
            }

            const parsed = Number(extraOrder);
            return Number.isNaN(parsed) || !Number.isInteger(parsed) || parsed <= 0;
          });
        });
      };
      if (this.popupBatchUpdate.price.action === "update") {
        if (this.popupBatchUpdate.select.roomType.length === 0 || this.popupBatchUpdate.select.ratePlan.length === 0 || this.popupBatchUpdate.select.ota.length === 0) {
          _alert("null", this.$t("PLEASE_COMPLETE_THE_FIELDS_MARKED"));
          return
        }
        this.popupBatchUpdate.price.hasRoomRate.filter(temp =>
            this.popupBatchUpdate.select.roomType.includes(temp.roomTypeId) && temp.roomRates && temp.roomRates.length > 0
          ).forEach(room => {
          room.roomRates.filter(temp =>
            this.popupBatchUpdate.select.ratePlan.includes(temp.ratePlanId) && temp.ota
          ).forEach(plan => {
            plan.ota.filter(temp =>
            this.popupBatchUpdate.select.ota.includes(temp.ota.id) && temp.dates
          ).forEach(detail => {
              var dateValue = [];
              detail.dates.forEach(date => {
                let fromDate = moment(date.dateSelect[0], "YYYY/MM/DD");
                let toDate = moment(date.dateSelect[1], "YYYY/MM/DD");
                while (fromDate <= toDate) {
                  let daysOfWeek = this.formatDateOfWeek(fromDate);

                  if (date[daysOfWeek].value && date[daysOfWeek].value != "0") {
                    dateValue.push({
                      appliedDate: fromDate.format("YYYY-MM-DD"),
                      pricePax: date[daysOfWeek].value,
                      extraType: this.popupBatchUpdate.price.extraTypeSelected,
                      extraOrder: date.numberPerson
                    });
                  }
                  fromDate = moment(fromDate).add(1, "day");
                }
              });
              if (dateValue.length > 0) {
                body.push({
                  id: detail.roomrateId,
                  persons: dateValue
                });
              }
            });
          });
        });
        if (!check && body.length > 0) {
          this.popupBatchUpdate.isLoading = true;
          body.forEach(item => {
							item.persons.forEach(e => {
								e.pricePax = this.formatMoney(+e.pricePax, this.usedCurrency)
							})
						})
          if (hasInvalidExtraOrder(body)) {
            this.popupBatchUpdate.isLoading = false;
            _alert(null, this.$t("VALUE_AND_PERSON_IS_REQUIRED"));
            return;
          }
          
          sale_room
            .updateSpecialPriceExtra(body)
            .then(res => {
              _alert(res, this.$t(res.data), false);
            })
            .finally(() => (this.popupBatchUpdate.isLoading = false));
        } else {
          _alert(null, this.$t("DATA_INPUT_INVALID"));
        }
      } else if (this.popupBatchUpdate.price.action === "massUpdate") {
        if (this.popupBatchUpdate.select.roomType.length === 0 || this.popupBatchUpdate.select.ratePlan.length === 0 || this.popupBatchUpdate.select.ota.length === 0) {
          _alert("null", this.$t("PLEASE_COMPLETE_THE_FIELDS_MARKED"));
          return
        }
        this.popupBatchUpdate.price.roomRateSelect = []
        this.popupBatchUpdate.price.hasRoomRate.forEach(room => {
          room.roomRates.forEach(plan => {
            plan.ota.forEach(rr => {
              if (this.popupBatchUpdate.select.roomType.includes(room.roomTypeId) 
              && this.popupBatchUpdate.select.ratePlan.includes(plan.ratePlanId) 
              && this.popupBatchUpdate.select.ota.includes(rr.ota.id)) {
                this.popupBatchUpdate.price.roomRateSelect.push(rr.roomrateId)
              }
            })
          })
        })
        if (this.popupBatchUpdate.price.roomRateSelect.length === 0) {
          return
        }
        this.popupBatchUpdate.price.roomRateSelect.forEach(detail => {
          var dateValue = [];
          this.massDate.forEach(date => {
            let fromDate = moment(date.dateSelect[0], "YYYY/MM/DD");
            let toDate = moment(date.dateSelect[1], "YYYY/MM/DD");
            while (fromDate <= toDate) {
              let daysOfWeek = this.formatDateOfWeek(fromDate);

              if (date[daysOfWeek].value && date[daysOfWeek].value != "0") {
                dateValue.push({
                  appliedDate: fromDate.format("YYYY-MM-DD"),
                  pricePax: date[daysOfWeek].value,
                  extraType: this.popupBatchUpdate.price.extraTypeSelected,
                  extraOrder: date.numberPerson
                });
              }
              fromDate = moment(fromDate).add(1, "day");
            }
          });
          if (dateValue.length > 0) {
            body.push({
              id: detail,
              persons: dateValue
            });
          }
        });
        if (!check && body.length > 0) {
          this.popupBatchUpdate.isLoading = true;
          body.forEach(item => {
							item.persons.forEach(e => {
								e.pricePax = this.formatMoney(+e.pricePax, this.usedCurrency)
							})
						})
          if (hasInvalidExtraOrder(body)) {
            this.popupBatchUpdate.isLoading = false;
            _alert(null, this.$t("VALUE_AND_PERSON_IS_REQUIRED"));
            return;
          }
          sale_room
            .updateSpecialPriceExtra(body)
            .then(res => {
              _alert(res, this.$t(res.data), false);
            })
            .finally(() => (this.popupBatchUpdate.isLoading = false));
        } else {
          _alert(null, this.$t("DATA_INPUT_INVALID"));
        }
      } else {
        if (this.popupBatchUpdate.select.roomType.length === 0 || this.popupBatchUpdate.select.ratePlan.length === 0 || this.popupBatchUpdate.select.ota.length === 0) {
          _alert("null", this.$t("PLEASE_COMPLETE_THE_FIELDS_MARKED"));
          return
        }
        this.popupBatchUpdate.price.hasRoomRate.filter(temp =>
            this.popupBatchUpdate.select.roomType.includes(temp.roomTypeId) && temp.roomRates
          ).forEach(room => {
          room.roomRates.filter(temp =>
            this.popupBatchUpdate.select.ratePlan.includes(temp.ratePlanId) && temp.ota
          ).forEach(plan => {
            plan.ota.filter(temp =>
            this.popupBatchUpdate.select.ota.includes(temp.ota.id) && temp.dates
          ).forEach(detail => {
              var dateValue = [];
              detail.dates.forEach(date => {
                let fromDate = moment(date.dateSelect[0], "YYYY/MM/DD");
                let toDate = moment(date.dateSelect[1], "YYYY/MM/DD");
                while (fromDate <= toDate) {
                  let daysOfWeek = this.formatDateOfWeek(fromDate);

                  if (date[daysOfWeek].value != null) {
                    dateValue.push({
                      appliedDate: fromDate.format("YYYY-MM-DD"),
                      extraType: this.popupBatchUpdate.price.extraTypeSelected,
                      extraOrder: date.numberPerson
                    });
                  }
                  fromDate = moment(fromDate).add(1, "day");
                }
              });
              if (dateValue.length > 0) {
                body.push({
                  id: detail.roomrateId,
                  persons: dateValue
                });
              }
            });
          });
        });
        if (!check && body.length > 0) {
          if (hasInvalidExtraOrder(body)) {
            _alert(null, this.$t("VALUE_AND_PERSON_IS_REQUIRED"));
            return
          }
          this.popupBatchUpdate.isLoading = true;
          sale_room
            .deleteSpecialPriceExtra(body)
            .then(res => {
              _alert(res, this.$t(res.data), false);
            })
            .finally(() => (this.popupBatchUpdate.isLoading = false));
        } else {
          _alert(null, this.$t("VALUE_AND_PERSON_IS_REQUIRED"));
        }
      }
    },
    addDatePriodSpecialPrice() {
        this.objectCopy = null;
      let prevPeriod = this.popupBatchUpdate.price.hasRoomRate[0].roomRates[0]
        .ota[0].dates[
        this.popupBatchUpdate.price.hasRoomRate[0].roomRates[0].ota[0].dates
          .length - 1
      ];
      const tomorrow = new Date();
      tomorrow.setDate(new Date().getDate() + 365*2);
      if (
        new Date(moment(prevPeriod.dateSelect[1]).format("YYYY-MM-DD")) >=
        tomorrow
      ) {
        return;
      }
      let from = moment(prevPeriod.dateSelect[1])
        .add(1, "day")
        .format("YYYY-MM-DD");
      let to = moment(prevPeriod.dateSelect[1])
        .add(2, "day")
        .format("YYYY-MM-DD");
      this.popupBatchUpdate.price.hasRoomRate.forEach(room => {
        room.roomRates.forEach(plan => {
          plan.ota.forEach(detail => {
            detail.dates.push({
              dateSelect: [new Date(from), new Date(to)],
              MON: {
                value: null,
                disable: true
              },
              TUE: {
                value: null,
                disable: true
              },
              WED: {
                value: null,
                disable: true
              },
              THU: {
                value: null,
                disable: true
              },
              FRI: {
                value: null,
                disable: true
              },
              SAT: {
                value: null,
                disable: true
              },
              SUN: {
                value: null,
                disable: true
              },
              numberPerson: +prevPeriod.numberPerson
            });
          });
        });
      });
    },
    addDatePriodSpecialPriceMass() {
      let prevPeriod = this.massDate[this.massDate.length - 1];
      const tomorrow = new Date();
      tomorrow.setDate(new Date().getDate() + 365*2);
      if (
        new Date(moment(prevPeriod.dateSelect[1]).format("YYYY-MM-DD")) >=
        tomorrow
      ) {
        return;
      }
      let from = moment(prevPeriod.dateSelect[1])
        .add(1, "day")
        .format("YYYY-MM-DD");
      let to = moment(prevPeriod.dateSelect[1])
        .add(2, "day")
        .format("YYYY-MM-DD");
      this.massDate.push({
        dateSelect: [new Date(from), new Date(to)],
        MON: {
          value: null,
          disable: true
        },
        TUE: {
          value: null,
          disable: true
        },
        WED: {
          value: null,
          disable: true
        },
        THU: {
          value: null,
          disable: true
        },
        FRI: {
          value: null,
          disable: true
        },
        SAT: {
          value: null,
          disable: true
        },
        SUN: {
          value: null,
          disable: true
        },
        numberPerson: +prevPeriod.numberPerson
      });
    },
    removePeriodSpecialPrice(index) {
      this.objectCopy = null;
      this.popupBatchUpdate.price.hasRoomRate.forEach(room => {
        room.roomRates.forEach(plan => {
          plan.ota.forEach(detail => {
            detail.dates.splice(index, 1);
          });
        });
      });
    },
    removePeriodSpecialPriceMass(index) {
      this.massDate.splice(index, 1);
    },
    formatDateOfWeek(date) {
      let dayOfWeek;
      switch (date.day()) {
        case 0: {
          dayOfWeek = "SUN";
          break;
        }
        case 1: {
          dayOfWeek = "MON";
          break;
        }
        case 2: {
          dayOfWeek = "TUE";
          break;
        }
        case 3: {
          dayOfWeek = "WED";
          break;
        }
        case 4: {
          dayOfWeek = "THU";
          break;
        }
        case 5: {
          dayOfWeek = "FRI";
          break;
        }
        case 6: {
          dayOfWeek = "SAT";
          break;
        }
      }
      return dayOfWeek;
    },
    _moment: moment
  }
};
</script>
